
export function findGlobalIndex (id, sections = []) {
  let j = 0 
  for (let i = 0; i < sections.length; i++) {
    const section = sections[i]
    const index = section.questions.findIndex(q => q.id == id)
    if (index >= 0) return j + index
    j += section.questions.length
  }
  return -1
}

